/** Slim mid-page prompt that sends a reader who is done scrolling back to the studio. */
export function ToolInlineCta({
  title,
  body,
  actionLabel,
  actionHref,
  onAction,
}: {
  onAction?: () => void;
  title: string;
  body: string;
  actionLabel: string;
  actionHref: string;
}) {
  return (
    <aside className="flex flex-col items-start justify-between gap-4 rounded-2xl border border-border bg-card px-6 py-5 sm:flex-row sm:items-center">
      <div>
        <p className="text-base font-semibold text-foreground">{title}</p>
        <p className="mt-0.5 text-sm text-muted-foreground">{body}</p>
      </div>
      <a
        href={actionHref}
        onClick={onAction}
        className="inline-flex h-11 shrink-0 items-center rounded-full bg-primary px-6 text-sm font-semibold text-primary-foreground shadow-sm transition-transform hover:-translate-y-0.5"
      >
        {actionLabel}
      </a>
    </aside>
  );
}
